<template>
  <div class="dashboard py-5" v-if="statsLoaded">
    <span class="page-title" >{{$t("intranet.title.page.home")}}</span>
    <v-container class="dashboard-container ml-xl-8 mr-xl-16 mr-lg-5 mr-lg-10">

      <v-row class="dashboard-tabs d-flex flex-xl-row flex-lg-row flex-md-row flex-column flex-wrap justify-space-between">
        <v-col cols="7" class="tab stats d-flex flex-column flex-grow-1 flex-shrink-0 mb-lg-6 mx-lg-10">
          <router-link :to="{ name: 'OrderStats' }">
            <h3 class="text-uppercase">{{$t("intranet.dashboard.activity")}}</h3>
          </router-link>
          <v-col class="d-flex align-center justify-center">
            <AveineSaleCharts :APIbaseURL="APIbaseURL" class="component" :adminMode="true" :dashboardActions="true"/>
          </v-col>
        </v-col>
        <v-col cols="3" class="tab d-flex flex-column justify-sm-center flex-shrink-1 flex-grow-0 transactions ma-lg-8 mt-16 mb-6 lg-10">
          <router-link :to="{ name: 'OrderIndex' }">
            <h3 class="text-uppercase ml-10">{{$t("intranet.dashboard.lastSales")}}</h3>
          </router-link>
          <v-list class="d-flex flex-column justify-center ml-lg-6 ml-2 mt-8" dense>
            <v-list-item
              v-for="(order, i) in lastSales"
              :key="i"
            >
              <v-list-item-avatar size="40">
                <v-img src="@/assets/shopify.jpg"></v-img>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="text-subtitle-1" v-if="order.customer" v-text="order.customer.display_name"></v-list-item-title>
                <v-list-item-title class="text-subtitle-1" v-else>-</v-list-item-title>
                <v-list-item-subtitle class="text-subtitle-2">
                  {{order.order_products[0].quantity}} {{order.order_products[0].product_name}}
                  <span v-if="order.order_products[1] && order.order_products[1].quantity"> + </span> <br>
                  {{$t("intranet.dashboard.shop")}} {{order.shop.id}}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-col>
      </v-row>
    </v-container>
  </div>
  <div v-else class="mt-16">
    <div class="d-flex flex-row align-center justify-center flex-wrap">
      <v-skeleton-loader
        type="article, actions"
        class="ma-4"
        v-for="index in 4" :key="index"
      ></v-skeleton-loader>
    </div>
    <div class="d-flex flex-row align-center justify-center flex-wrap">
      <v-skeleton-loader
        type="article, actions"
        class="ma-10"
        v-for="index in 2" :key="index"
      ></v-skeleton-loader>
    </div>
  </div>
</template>

<script>

import { Order } from 'aveine-toolbox'
import { AveineSaleCharts } from 'aveine-sale/src/wrapper'
import { errorHandler } from 'aveine-toolbox'
export default {
  name: 'Dashboard',
  components: {
    AveineSaleCharts
  },
  data () {
    return {
      orders: [],
      date1: null,
      date2: null,
      menu1: false,
      menu2: false,
      modelList: ['wineForms', 'ambassadors', 'domains', 'wines'],
      lastSales: [],
      statsLoaded: false,
      statsError: false,
      startDate: String,
      endDate: new Date().toISOString().substr(0, 10),
      pendingWineForms: Number,
      wineForms: {},
      ambassadors: {},
      domains: {},
      pendingComments: Number,
      wines: {},
      dataLoaded: false,
      authToken: null,
      APIbaseURL: process.env.VUE_APP_API_HOST
    }
  },
  computed: {
    /**
     * Calculate valid start date for stats time period
     * @type {String}
     */
    checkedStartDate() {
      let currentDate = new Date();
      let startDate = new Date(`${currentDate.getFullYear()}-${(currentDate.getMonth())}-${currentDate.getDate()}`); 
      if (currentDate.getMonth() == 0) {
        startDate = new Date(`${currentDate.getFullYear()-1}-12-${currentDate.getDate()}`);
      } else {
        let i = 1;
        while (isNaN(startDate)) {
          startDate = new Date(`${currentDate.getFullYear()}-${(currentDate.getMonth())}-${currentDate.getDate()-i}`);
          i++;
        }
      }

      return startDate.toISOString().substr(0, 10);
    },
  },
  async mounted() {
    try {
      this.authToken = await this.$auth.getTokenSilently();

      let lastSales = await Order.api().get(`/orders?lang=${this.$i18n.locale}`, {
        baseURL: this.APIbaseURL,
        params: {
          include: "shop,customer,order-products",
          sort: "-created-at",
          "page[size]": 5
        }
      });

      lastSales.response.data.map(async (sale) => {
        this.lastSales.push(await Order.query().whereId(sale.id).withAllRecursive().first());
      });      

      this.startDate = this.checkedStartDate;
      this.statsLoaded = true;
    } catch (errors) {
      errorHandler(errors, this)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import "aveine-toolbox/src/assets/style/algolia-min";
  

  @media all and (min-width: 1904px) {
    div.dashboard-container {
      width: 86vw;
      margin-left: 7vw !important;
      margin-right: 7vw !important;
    }
  }

  div.timeframe-selectors {
    max-height: 5vh;
  }
  div.loading-stats {
    height: 12vw;
  }
  div.dashboard-stat-tabs {
    div.tab {
      min-height: 175px;
      max-width: 18vw;
      box-shadow: 0 3px 5px 1px #80808069;
      background-color: white;
      border-radius: 0 20px 20px 20px;
      .tab-images {
        max-width: 60px;
        max-height: 100%;
      }
      span.numbers {
        font-weight: lighter;

        b {
          font-weight: bolder;
          font-size: 16px;
        }
      }
    }
  }

  @media all and (max-width: 720px) {
    div.timeframe-selectors {
      max-height: 20vh !important;
    }

    div.dashboard-stat-tabs {
      div.tab {
        max-width: 98vw !important;
      }
    }
    div.dashboard-tabs {
      div.tab {
        max-width: 98vw !important;
      }
    }
  }
  @media all and (min-width: 721px) and (max-width: 1903px) {
    div.dashboard-stat-tabs {
      div.tab {
        max-width: 24vw !important;
      }
    }
  }

  div.dashboard-tabs {
    div.tab {
      min-height: 175px;
      box-shadow: 0 3px 5px 1px #80808069;
      background-color: white;
      border-radius: 0 20px 20px 20px;
    }
    div.stats {
      height: 100%;
      width: inherit;
      padding: 15px;
    }

    div.transactions {
      height: inherit;
      width: inherit;
      div.md-list-item-inner {
        padding: 0;
        width: 100%;
      }
    }
    @media all and (max-width: 720px) {
      div.stats, div.transactions {
        width: 98vw !important;
        margin: auto;
      }
    }
  }
</style>
